var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentProps)?_c('searchable-list',_vm._b({},'searchable-list',_vm.componentProps,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }